<template>
  <div>
    <div v-if="path == 'channelFranchisee'">
      <header-top></header-top>
      <div class="header-title">分销商门店</div>
      <div class="content">
        <!-- 选择筛选 -->
        <div class="btn-group flex-between">
          <!-- 顶部左侧 -->
          <div class="flex">
            <el-button type="primary" @click="createCompany"
              >添加分销商门店</el-button
            >
            <el-button @click="deleteCompanys">批量删除</el-button>
            <span class="line"></span>
            <!-- 选择时间(几天前) -->
            <el-select
              v-model="dateValue"
              @change="selectDate"
              placeholder="请选择"
              class="handle-select time"
              :class="{ custom: dateValue == '自定义时间' }"
            >
              <el-option
                v-for="item in dateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- 自定义时间 -->
            <el-date-picker
              v-if="!filterDateReadonly"
              @change="getCompanyStores"
              class="filter-date"
              :readonly="filterDateReadonly"
              v-model="filterDate"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </div>
          <!-- 顶部右侧 -->
          <div class="flex btn-group-right">
            <el-select
              v-model="searchSelect"
              @change="filterSelect"
              placeholder="请选择"
              class="search-type"
            >
              <el-option
                v-for="item in searchTypeOptions"
                :key="item.key"
                :label="item.key"
                :value="item.value"
              ></el-option>
            </el-select>
            <div class="search">
              <el-input
                class="input"
                v-model="searchFilter"
                :placeholder="filterSelectPlaceholder"
                @keyup.enter.native="getCompanyStores()"
              >
                <i
                  class="el-icon-search el-input__icon input__suffix"
                  slot="suffix"
                  @click="getCompanyStores()"
                ></i>
              </el-input>
            </div>
            <el-popover
              class="btn-group-right-btn"
              placement="top"
              title
              width="30"
              height="49"
              trigger="hover"
              content="刷新"
            >
              <div slot="reference">
                <div @click="getCompanyStores('refresh')">
                  <svg-icon class="svg" icon-class="refresh-ico" />
                </div></div
            ></el-popover>
            <el-popover
              class="btn-group-right-btn"
              placement="top"
              title
              width="30"
              height="49"
              trigger="hover"
              content="设置"
            >
              <div slot="reference">
                <div @click="isShowFiltrate = true">
                  <svg-icon class="svg" icon-class="filtrate-ico" />
                </div>
              </div>
            </el-popover>
            <el-popover
              class="btn-group-right-btn"
              placement="top"
              title
              width="30"
              height="49"
              trigger="hover"
              content="下载"
            >
              <div slot="reference">
                <div @click="derive">
                  <svg-icon class="svg" icon-class="derive-ico" />
                </div></div
            ></el-popover>
          </div>
        </div>
        <!-- 筛选标签 -->
        <div class="tag-filter flex" v-if="statusFilter || typeFilter">
          <div style="font-weight: bold">当前已选条件：</div>
          <div class="item flex-between" v-if="typeFilter">
            <div>
              <span>类型：</span>
              <span class="keys">{{ typeFilter }}</span>
            </div>
            <div @click="clearFilters('type')">
              <svg-icon class="close" icon-class="close-ico"></svg-icon>
            </div>
          </div>
          <div class="item flex-between" v-if="statusFilter">
            <div>
              <span>状态：</span>
              <span class="keys">{{ statusFilter }}</span>
            </div>
            <div @click="clearFilters('status')">
              <svg-icon class="close" icon-class="close-ico"></svg-icon>
            </div>
          </div>
          <div class="clean" @click="clearFilters('all')">
            <svg-icon class="icon" icon-class="clean-ico"></svg-icon>清空条件
          </div>
        </div>
        <!-- 主要内容 -->
        <div class="main">
          <!-- 表格 -->
          <div class="table-box">
            <el-table
              class="table"
              stripe
              ref="multipleTable"
              :data="companies"
              tooltip-effect="dark"
              @selection-change="handleSelectionChange"
              @filter-change="handleFilterChange"
            >
              <el-table-column type="selection"></el-table-column>
              <el-table-column
                v-if="tableTitleKey.includes('门店名称')"
                prop="name"
                label="门店名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                :filters="companyTypeOptions"
                :filter-multiple="false"
                column-key="type"
                label-class-name="tab-tit tit-enable-click"
                v-if="tableTitleKey.includes('门店类型')"
                prop="type"
                label="门店类型"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                :filters="companyStatusOptions"
                :filter-multiple="false"
                column-key="status"
                v-if="tableTitleKey.includes('门店状态')"
                prop="status"
                label="门店状态"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                v-if="tableTitleKey.includes('关联分销商')"
                prop="company"
                label="关联分销商"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.company && scope.row.company.name">
                    {{ scope.row.company.name | nullValue }}
                  </span>
                  <span v-else>—</span>
                </template>
              </el-table-column>
              
              <el-table-column
                v-if="tableTitleKey.includes('联系电话')"
                prop="phoneNumber"
                label="联系电话"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.phoneNumber | nullValue }}</div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="tableTitleKey.includes('关联组织')"
                prop="organization"
                label="关联组织"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.organization && scope.row.organization.name">
                    {{ scope.row.organization.name | nullValue }}
                  </span>
                  <span v-else>—</span>
                </template>
              </el-table-column>
              
              <!-- <el-table-column
                
                v-if="tableTitleKey.includes('电子邮箱')"
                prop="email"
                label="电子邮箱"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                
                v-if="tableTitleKey.includes('公司法人')"
                prop="owner"
                label="公司法人"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.owner | nullValue }}</div>
                </template>
              </el-table-column>
              <el-table-column
                
                v-if="tableTitleKey.includes('营业执照号码')"
                prop="businessLicense"
                label="营业执照号码"
                show-overflow-tooltip
              ></el-table-column> -->
              <el-table-column
                v-if="tableTitleKey.includes('工商注册地址')"
                prop="registerAddress"
                label="工商注册地址"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.registerAddress | nullValue }}</div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="tableTitleKey.includes('门店地址')"
                prop="currentAddress"
                label="门店地址"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.currentAddress | nullValue }}</div>
                </template>
              </el-table-column>
              
              <el-table-column
                v-if="tableTitleKey.includes('维护人')"
                prop="user"
                label="维护人"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.user && scope.row.user.name">
                    {{ scope.row.user.name | nullValue }}
                  </span>
                  <span v-else>—</span>
                </template>
              </el-table-column>
              <el-table-column prop="more" label="操作">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="editCompany(scope.$index, scope.row)"
                    type="text"
                    >管理</el-button
                  >
                  <el-popover placement="bottom" trigger="click">
                    <el-button
                      @click.native.prevent="
                        deleteCompanyStore(scope.$index, scope.row.id)
                      "
                      type="text"
                      class="del-btn"
                      >删除</el-button
                    >
                    <el-button slot="reference" type="text" class="more-btn"
                      >更多</el-button
                    >
                  </el-popover>
                </template>
              </el-table-column>

              <template slot="empty">
                <div class="loading-box" v-if="isLoading">
                  <img
                    src="@/assets/image/loading.png"
                    alt="loading"
                    class="loading-ico"
                  />
                  数据加载中...
                </div>
                <div class="empty-box" v-if="!isLoading && !companies.length">
                  列表为空
                </div>
              </template>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              class="pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="pageIndex"
              :page-sizes="[10, 20, 30, 50, 100]"
              :page-size="query.maxResultCount"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- 自定义列表字段 穿梭框 -->
      <el-dialog
        title="自定义列表字段 "
        :visible.sync="isShowFiltrate"
        width="800px"
        :before-close="closeFiltrate"
        custom-class="filter-dialog"
      >
        <el-transfer
          filterable
          :filter-method="filterMethod"
          :titles="['请选择你想显示的列表字段', '已选择字段']"
          filter-placeholder="请输入字段名称"
          v-model="tableTitleKey"
          :data="tabTitData"
        ></el-transfer>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isShowFiltrate = false">取消</el-button>
          <el-button type="primary" @click="isShowFiltrate = false"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import indexJs from "./index.js";
export default {
  ...indexJs,
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.content {
  margin: 20px;
  padding: 20px;
  background-color: #fff;
  .btn-group {
    padding-bottom: 14px;
    .btn-group-right {
      padding-right: 7px;
    }
    .filter-date {
      border-left-color: transparent;
      border-radius: 0px 4px 4px 0;
      &:hover {
        border-color: #ddd;
        border-left-color: transparent;
      }
      &.isactive {
        border-color: $--color-primary;
      }
    }
    .handle-select {
      margin-left: 10px;
      &.time {
        width: 120px;
      }
      &.custom {
        ::v-deep .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }
    }
    .search-type {
      width: 100px;
      ::v-deep .el-input__inner {
        border-right: 0;
        border-radius: 4px 0 0 4px;
      }
    }
    .search {
      ::v-deep .el-input__inner {
        border-radius: 0 4px 4px 0;
      }
    }
    .line {
      width: 1px;
      height: 23px;
      background: #ddd;
      margin-left: 10px;
    }

    .btn-group-right-btn {
      margin-left: 13px;
      cursor: pointer;
    }
  }

  .tag-filter {
    padding: 14px 0;
    color: #000;
    border-top: 1px solid #ddd;

    .item {
      height: 24px;
      border: 1px solid #ccc;
      padding: 0 10px;
      box-sizing: border-box;
      margin-right: 10px;
      cursor: pointer;
      &:hover {
        background: #fafafa;
      }
      .close {
        width: 8px;
        height: 8px;
        cursor: pointer;
      }
      .keys {
        padding: 0 4px;
      }
    }

    .clean {
      cursor: pointer;
      padding-left: 15px;
      color: #434343;

      .icon {
        width: 14px;
        height: 12px;
        margin-right: 6px;
      }
    }
  }

  .main {
    // box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    background-color: #fff;
    border-radius: $--border-radius-base;
    align-items: flex-start;

    .main-tree {
      width: 320px;
      height: 100%;

      ::v-deep .el-checkbox__inner {
        z-index: 0;
      }
      ::v-deep .el-tree-node__content {
        height: 45px;
      }
      .search-box {
        padding: 30px 16px 10px;

        .title {
          font-size: 14px;
          color: #000;
          font-weight: bold;
          text-align: left;
          padding-bottom: 30px;
        }
      }
    }

    .table-box {
      // border-left: 1px solid #ddd;
      position: relative;
      .el-table {
        // font-size: 12px;
      }
      // .table {
      //   // min-height: calc(100vh - 243px);
      // }
      .fold-img {
        position: absolute;
        width: 15px;
        height: 60px;
        left: -1px;
        top: 200px;
        z-index: 1;
        cursor: pointer;
      }

      .synchronization {
        color: $--color-primary;
        cursor: pointer;
      }

      .operation-log {
        color: $--color-primary;
        margin-right: 7px;
      }
      .pagination {
        // font-size: 12px;
        padding: 10px;
      }
    }
  }
}
.bright {
  color: #f29b38;
}
</style>
